import React, { Component } from 'react';
import { path } from 'ramda';

export default class Comment extends Component {

  constructor(props) {
    super(props);
    this.getUserNameById = this.getUserNameById.bind(this);
  }

  getUserNameById(data) {
    return data.firstname + ' ' + data.lastname;
  }

  render() {
    return (
      <div style={{ paddingBottom: '25px' }}>
        <b>{this.getUserNameById(this.props.data)} says:</b> <i>{this.props.data.content}</i> [{this.props.data.created}]
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/common/Comment/index.js